import { Vue } from 'vue-class-component';
export default class GridLayout extends Vue {}